import Intercom from '@module/intercom';
import Store from '@app/store';

const { account, session, user } = Store.getState();
const intercomSettings = window.__intercomSettings__ || {};

if (user) {
  intercomSettings.user_id = user.id;
  intercomSettings.email = user.email;
  intercomSettings.name = user.full_name;

  // Avatar
  if (account.profile_picture) {
    intercomSettings.avatar = {
      type: 'avatar',
      image_url: account.profile_picture.image_url,
    };
  }
}

Intercom.configure(intercomSettings);

if (session.tandc) {
  Intercom.boot();
}

delete window.__intercomSettings__;
